import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
@Component({
  selector: 'app-addshiftcloseemail',
  templateUrl: './addshiftcloseemail.component.html',
  styleUrls: ['./addshiftcloseemail.component.css']
})
export class AddshiftcloseemailComponent implements OnInit  {


  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;

  errtxt: any = "";

 
 
 
  //pageColl:any=[];

  shiftcloseform = new FormGroup({
    shiftcloseid:  new FormControl(0),
    emailid: new FormControl(null, Validators.required),
    branchid: new FormControl(null),

  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "ShiftCloseEmail";

  @Input() shiftcloseid: number = 0
  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private activeModal: NgbActiveModal,) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.shiftcloseid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.shiftcloseform.reset();
      this.fnInitializeShiftCloseEmail();

     
      
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.shiftcloseid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
   


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeShiftCloseEmail() {
    this.shiftcloseform.setValue({
      shiftcloseid: 0,
      emailid:null,
      branchid:null,
    })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;

    //  this.fnResetValidation()
      //Validate
      if (this.shiftcloseform.valid) {

      //  this.fnValidation()
        //Check
        var data = {
          'shiftcloseid': this.shiftcloseid,
          'emailid': this.shiftcloseform.get('emailid').value,
          'branchid': this.shiftcloseform.get('branchid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckShiftCloseEmail(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
                //Insert Department
                this.fnInsertShiftCloseEmail(data);
            }
              else if (_checkresult === "name") {
                this.shiftcloseform.controls['emailid'].setErrors({ 'notfound': true });
             
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertShiftCloseEmail(data) {

    this.appService.fnInsertShiftCloseEmail(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.toastr.success('', "The new Email has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.emailid);

          this.emitData.emit(this.shiftcloseid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }



  //Close

  //Close
  public decline() {
    this.activeModal.close(false);
  }

  
fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
